module.exports = __webpack_public_path__ + "static/img/huli.0071c853.png";